export const loadPSPDFViewer = () => import(
  /* webpackChunkName: "viewer-pspdf" */
  './PSPDFViewer'
);

export const loadFallbackViewer = () => import(
  /* webpackChunkName: "viewer-fallback" */
  './FallbackViewer'
);

export const loadNutrientViewer = () => import(
  /* webpackChunkName: "viewer-nutrient" */
  './nutrient/NutrientViewer'
);
